var _class, _descriptor, _descriptor2;
function _initializerDefineProperty(target, property, descriptor, context) { if (!descriptor) return; Object.defineProperty(target, property, { enumerable: descriptor.enumerable, configurable: descriptor.configurable, writable: descriptor.writable, value: descriptor.initializer ? descriptor.initializer.call(context) : void 0 }); }
function _defineProperty(obj, key, value) { key = _toPropertyKey(key); if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return typeof key === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (typeof input !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (typeof res !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
function _applyDecoratedDescriptor(target, property, decorators, descriptor, context) { var desc = {}; Object.keys(descriptor).forEach(function (key) { desc[key] = descriptor[key]; }); desc.enumerable = !!desc.enumerable; desc.configurable = !!desc.configurable; if ('value' in desc || desc.initializer) { desc.writable = true; } desc = decorators.slice().reverse().reduce(function (desc, decorator) { return decorator(target, property, desc) || desc; }, desc); if (context && desc.initializer !== void 0) { desc.value = desc.initializer ? desc.initializer.call(context) : void 0; desc.initializer = undefined; } if (desc.initializer === void 0) { Object.defineProperty(target, property, desc); desc = null; } return desc; }
function _initializerWarningHelper(descriptor, context) { throw new Error('Decorating class property failed. Please ensure that ' + 'proposal-class-properties is enabled and runs after the decorators transform.'); }
import Service, { inject as service } from '@ember/service';
import approveDeviceUserCode from 'roomba/graphql/mutations/approveDeviceUserCode';
import checkCalendarPermissions from 'roomba/graphql/mutations/checkCalendarPermissions';
import createCompany from 'roomba/graphql/mutations/createCompany';
import createLocation from 'roomba/graphql/mutations/createLocation';
import deleteRoomBackgroundImage from 'roomba/graphql/mutations/deleteRoomBackgroundImage';
import linkRoomsWithLocation from 'roomba/graphql/mutations/linkRoomsWithLocation';
import putSpaceSaverCheckInExcludedRooms from 'roomba/graphql/mutations/putSpaceSaverCheckInExcludedRooms';
import putSpaceSaverRoomResizerExcludedOrganizers from 'roomba/graphql/mutations/putSpaceSaverRoomResizerExcludedOrganizers';
import putSpaceSaverRoomResizerExcludedRooms from 'roomba/graphql/mutations/putSpaceSaverRoomResizerExcludedRooms';
import synchronizeCompanyRoomList from 'roomba/graphql/mutations/synchronizeCompanyRoomList';
import unlinkConnection from 'roomba/graphql/mutations/unlinkConnection';
import unpairDevice from 'roomba/graphql/mutations/unpairDevice';
import updateCompanyConfig from 'roomba/graphql/mutations/updateCompanyConfig';
import updateLightedCaseType from 'roomba/graphql/mutations/updateLightedCaseType';
import updateLocationRoomsCheckInWindow from 'roomba/graphql/mutations/updateLocationRoomsCheckInWindow';
import updateRoomConfig from 'roomba/graphql/mutations/updateRoomConfig';
import updateRoomsCompanyOnsiteRoomRecaptureEnabled from 'roomba/graphql/mutations/updateRoomsCompanyOnsiteRoomRecaptureEnabled';
import updateRoomsCompanyRoomResizerEnabled from 'roomba/graphql/mutations/updateRoomsCompanyRoomResizerEnabled';
import updateRoomsLocationCheckInEnabledOverride from 'roomba/graphql/mutations/updateRoomsLocationCheckInEnabledOverride';
import updateRoomsLocationNotificationEmails from 'roomba/graphql/mutations/updateRoomsLocationNotificationEmails';
import updateRoomsLocationOnsiteRoomRecaptureEnabledOverride from 'roomba/graphql/mutations/updateRoomsLocationOnsiteRoomRecaptureEnabledOverride';
import updateRoomsLocationRoomResizerEnabledOverride from 'roomba/graphql/mutations/updateRoomsLocationRoomResizerEnabledOverride';
import updateRoomsLocationShouldEmailGlobalAdmins from 'roomba/graphql/mutations/updateRoomsLocationShouldEmailGlobalAdmins';
import updateRoomsLocationShouldEmailLocationAdmins from 'roomba/graphql/mutations/updateRoomsLocationShouldEmailLocalAdmins';
import getCompany from 'roomba/graphql/queries/getCompany';
import getDevicePairingStatus from 'roomba/graphql/queries/getDevicePairingStatus';
import getRoom from 'roomba/graphql/queries/getRoom';
import getRooms from 'roomba/graphql/queries/getRooms';
import getRoomsLocationWithConfigs from 'roomba/graphql/queries/getRoomsLocationWithConfigs';
import getRoomsPaginated from 'roomba/graphql/queries/getRoomsPaginated';
import getSpaceSaverConfig from 'roomba/graphql/queries/getSpaceSaverConfig';
let GraphqlService = (_class = class GraphqlService extends Service {
  constructor(...args) {
    super(...args);
    _initializerDefineProperty(this, "apolloExtension", _descriptor, this);
    _initializerDefineProperty(this, "state", _descriptor2, this);
  }
  async getCompany() {
    try {
      return await this.apolloExtension.watchQuery({
        query: getCompany
      }, 'company');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql getCompany query. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async getRooms(locationId = null) {
    try {
      return await this.apolloExtension.watchQuery({
        query: getRooms,
        fetchPolicy: 'network-only',
        variables: {
          filter: {
            ids: null,
            locationId
          }
        }
      }, 'rooms');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql getRooms query. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async getRoomsPaginated(filter, sort, pagination = null) {
    try {
      return await this.apolloExtension.watchQuery({
        query: getRoomsPaginated,
        fetchPolicy: 'network-only',
        variables: {
          filter,
          sort,
          pagination
        }
      }, 'paginatedRooms');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql getRoomsPaginated query. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async getRoom(id) {
    try {
      return await this.apolloExtension.watchQuery({
        query: getRoom,
        fetchPolicy: 'network-only',
        variables: {
          id
        }
      }, 'room');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql getRoom query. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async getRoomsLocationWithConfigs(id) {
    try {
      return await this.apolloExtension.watchQuery({
        query: getRoomsLocationWithConfigs,
        variables: {
          id
        }
      }, 'location');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql getRoomsLocationWithConfigs query. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async getDevicePairingStatus(id) {
    try {
      return await this.apolloExtension.query({
        query: getDevicePairingStatus,
        fetchPolicy: 'network-only',
        variables: {
          id
        }
      }, 'getDevicePairingStatus');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql getDevicePairingStatus query. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async linkRoomsWithLocation(roomIds, locationId) {
    try {
      return await this.apolloExtension.mutate({
        mutation: linkRoomsWithLocation,
        refetchQueries: [getRooms],
        variables: {
          roomIds,
          locationId
        }
      }, 'linkRoomsWithLocation');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql linkRoomsWithLocation mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async synchronizeCompanyRoomList() {
    try {
      return await this.apolloExtension.mutate({
        mutation: synchronizeCompanyRoomList,
        refetchQueries: [getRooms]
      }, 'synchronizeCompanyRoomList');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql synchronizeCompanyRoomList mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async unlinkConnection({
    connectionId,
    shouldDeleteAssociatedRooms
  }) {
    try {
      return await this.apolloExtension.mutate({
        mutation: unlinkConnection,
        refetchQueries: [getCompany],
        variables: {
          connectionId,
          shouldDeleteAssociatedRooms
        }
      }, 'unlinkConnection');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql unlinkConnection mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async unpairDevice(id) {
    try {
      return await this.apolloExtension.mutate({
        mutation: unpairDevice,
        refetchQueries: [getRoom],
        variables: {
          id
        }
      }, 'unpairDevice');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql unpairDevice mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async updateCompanyConfig(input = {}) {
    try {
      return await this.apolloExtension.mutate({
        mutation: updateCompanyConfig,
        // When company settings change, the location settings might change as well as they may inherit from the company
        refetchQueries: [getRoomsLocationWithConfigs],
        variables: {
          input
        }
      }, 'updateCompanyConfig');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql updateCompanyConfig mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async updateLightedCaseType(deviceId, caseType) {
    try {
      return await this.apolloExtension.mutate({
        mutation: updateLightedCaseType,
        variables: {
          deviceId,
          caseType
        }
      }, 'updateLightedCaseType');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql updateLightedCaseType mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async updateRoomConfig(input = {}) {
    try {
      return await this.apolloExtension.mutate({
        mutation: updateRoomConfig,
        variables: {
          input
        }
      }, 'updateRoomConfig');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql updateRoomConfig mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async checkCalendarPermissions(input) {
    try {
      return await this.apolloExtension.mutate({
        mutation: checkCalendarPermissions,
        variables: input
      }, 'checkCalendarPermissions');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql checkCalendarPermissions mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async updateRoomsLocationShouldEmailGlobalAdmins(locationId, shouldEmailGlobalAdmins) {
    try {
      return await this.apolloExtension.mutate({
        mutation: updateRoomsLocationShouldEmailGlobalAdmins,
        variables: {
          locationId,
          shouldEmailGlobalAdmins
        }
      }, 'updateRoomsLocationShouldEmailGlobalAdmins');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql updateRoomsLocationShouldEmailGlobalAdmins mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async updateRoomsLocationShouldEmailLocationAdmins(locationId, shouldEmailLocationAdmins) {
    try {
      return await this.apolloExtension.mutate({
        mutation: updateRoomsLocationShouldEmailLocationAdmins,
        variables: {
          locationId,
          shouldEmailLocationAdmins
        }
      }, 'updateRoomsLocationShouldEmailLocationAdmins');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql updateRoomsLocationShouldEmailLocationAdmins mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async updateRoomsLocationNotificationEmails(locationId, notificationEmails) {
    try {
      return await this.apolloExtension.mutate({
        mutation: updateRoomsLocationNotificationEmails,
        variables: {
          locationId,
          notificationEmails
        }
      }, 'updateRoomsLocationNotificationEmails');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql updateRoomsLocationNotificationEmails mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async updateRoomsLocationRoomResizerEnabledOverride(locationId, roomResizerEnabledOverride) {
    try {
      return await this.apolloExtension.mutate({
        mutation: updateRoomsLocationRoomResizerEnabledOverride,
        refetchQueries: [getRoomsLocationWithConfigs],
        variables: {
          locationId,
          roomResizerEnabledOverride
        }
      }, 'updateRoomsLocationRoomResizerEnabledOverride');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql updateRoomsLocationRoomResizerEnabledOverride mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async updateRoomsLocationCheckInEnabledOverride(locationId, roomCheckInEnabledOverride) {
    try {
      // eslint-disable-next-line @typescript-eslint/no-unsafe-return
      return await this.apolloExtension.mutate({
        mutation: updateRoomsLocationCheckInEnabledOverride,
        refetchQueries: [getRoomsLocationWithConfigs],
        variables: {
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          locationId,
          // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
          roomCheckInEnabledOverride
        }
      }, 'updateRoomsLocationRoomCheckInEnabledOverride');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql updateRoomsLocationCheckInEnabledOverride mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async updateRoomsLocationOnsiteRoomRecaptureEnabledOverride(locationId, onsiteRoomRecaptureEnabledOverride) {
    try {
      return await this.apolloExtension.mutate({
        mutation: updateRoomsLocationOnsiteRoomRecaptureEnabledOverride,
        refetchQueries: [getRoomsLocationWithConfigs],
        variables: {
          locationId,
          onsiteRoomRecaptureEnabledOverride
        }
      }, 'updateRoomsLocationOnsiteRoomRecaptureEnabledOverride');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql updateRoomsLocationOnsiteRoomRecaptureEnabledOverride mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async updateRoomsCompanyOnsiteRoomRecaptureEnabled(companyId, onsiteRoomRecaptureEnabled) {
    try {
      return await this.apolloExtension.mutate({
        mutation: updateRoomsCompanyOnsiteRoomRecaptureEnabled,
        refetchQueries: [getCompany, getRoomsLocationWithConfigs],
        variables: {
          companyId,
          onsiteRoomRecaptureEnabled
        }
      }, 'updateRoomsCompanyOnsiteRoomRecaptureEnabled');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql updateRoomsLocationOnsiteRoomRecaptureEnabledOverride mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async updateRoomsCompanyRoomResizerEnabled(companyId, roomResizerEnabled) {
    try {
      return await this.apolloExtension.mutate({
        mutation: updateRoomsCompanyRoomResizerEnabled,
        refetchQueries: [getCompany, getRoomsLocationWithConfigs],
        variables: {
          companyId,
          roomResizerEnabled
        }
      }, 'updateRoomsCompanyRoomResizerEnabled');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql updateRoomsLocationOnsiteRoomRecaptureEnabledOverride mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }

  // to be used temporarily for local development only
  async createCompany() {
    // TODO how do we handle shared services?
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment, @typescript-eslint/no-explicit-any
    const {
      currentCompany
    } = this.state;
    // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
    const {
      id: companyId
    } = currentCompany;
    let pairingCode = '';
    const characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
    for (let i = 0; i < 6; i++) {
      pairingCode += characters.charAt(Math.floor(Math.random() * characters.length));
    }
    try {
      return await this.apolloExtension.mutate({
        mutation: createCompany,
        variables: {
          input: {
            // eslint-disable-next-line @typescript-eslint/no-unsafe-assignment
            id: companyId,
            // eslint-disable-next-line @typescript-eslint/restrict-template-expressions
            name: `company ${companyId}`,
            pairingCode
          }
        }
      }, 'createCompany');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql createCompany mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }

  // to be used temporarily for local development only
  async createLocation(input) {
    try {
      return await this.apolloExtension.mutate({
        mutation: createLocation,
        variables: {
          input
        }
      }, 'createLocation');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql createLocation mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async approveDeviceUserCode(userCode, roomId) {
    try {
      return await this.apolloExtension.mutate({
        mutation: approveDeviceUserCode,
        variables: {
          userCode,
          roomId
        }
      }, 'approveDeviceUserCode');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql approveDeviceUserCode mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async deleteRoomBackgroundImage(roomId) {
    try {
      return await this.apolloExtension.mutate({
        mutation: deleteRoomBackgroundImage,
        variables: {
          roomId
        }
      }, 'deleteRoomBackgroundImage');
    } catch (e) {
      // eslint-disable-next-line
      console.error('Error calling graphql deleteRoomBackgroundImage mutation. Error: ', JSON.stringify(e));
      throw e;
    }
  }
  async putSpaceSaverRoomResizerExcludedRooms(companyId, roomIds) {
    return await this.apolloExtension.mutate({
      mutation: putSpaceSaverRoomResizerExcludedRooms,
      variables: {
        companyId,
        roomIds
      },
      refetchQueries: [getSpaceSaverConfig]
    }, 'putSpaceSaverRoomResizerExcludedRooms');
  }
  async putSpaceSaverRoomResizerExcludedOrganizers(companyId, organizerEmails) {
    return await this.apolloExtension.mutate({
      mutation: putSpaceSaverRoomResizerExcludedOrganizers,
      variables: {
        companyId,
        organizerEmails
      },
      refetchQueries: [getSpaceSaverConfig]
    }, 'putSpaceSaverRoomResizerExcludedOrganizers');
  }
  async updateLocationRoomsCheckInWindow(locationId, roomsCheckInWindow, roomsPreCheckInWindow) {
    return await this.apolloExtension.mutate({
      mutation: updateLocationRoomsCheckInWindow,
      variables: {
        locationId,
        roomsCheckInWindow,
        roomsPreCheckInWindow
      },
      refetchQueries: [getRoomsLocationWithConfigs]
    }, 'updateLocationRoomsCheckInWindow');
  }
  async putSpaceSaverCheckInExcludedRooms(companyId, roomIds) {
    return await this.apolloExtension.mutate({
      mutation: putSpaceSaverCheckInExcludedRooms,
      variables: {
        companyId,
        roomIds
      },
      refetchQueries: [getSpaceSaverConfig]
    }, 'putSpaceSaverCheckInExcludedRooms');
  }
  async getSpaceSaverConfig() {
    return await this.apolloExtension.watchQuery({
      query: getSpaceSaverConfig
    }, 'spaceSaverConfig');
  }
}, (_descriptor = _applyDecoratedDescriptor(_class.prototype, "apolloExtension", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
}), _descriptor2 = _applyDecoratedDescriptor(_class.prototype, "state", [service], {
  configurable: true,
  enumerable: true,
  writable: true,
  initializer: null
})), _class);
export { GraphqlService as default };